export default __webpack_public_path__ + "static/media/guess-friends-3.867dc898.jpg";